var myFlavr = {
	title : "操作提示",
	getTitle : function(title) {
		title = title || this.title;
		return "<div class='flavr-title-content'>" + title
				+ "<a href='#' class='flavr-title-close'></a></div>";
	},
	getContent : function(message) {
		return "<div class='flavr-message-content'>" + message + "</div>";
	}
}
/**
 * 需要一个按钮的方法
 * 
 * @param submitCallback
 *            点击确定后操作 回调函数
 */
String.prototype.showMessage = function(submitCallback) {
	var modeless = new $.flavr({
		title : myFlavr.getTitle(),
		content : myFlavr.getContent(this),
		buttons : {
			primary : {
				style : 'primary',
				text : '确定',
				action : submitCallback
			}
		},
		onBuild : function() {
			$('.flavr-title-close').click(function() {
				modeless.close();
			});
		}
	});
};
/**
 * 需要两个按钮的方法
 * 
 * @param submitCallback
 *            点击确定后操作 回调函数
 * @param calcelCallback
 *            点击取消 操作，可不传
 */
String.prototype.showConfirm = function(submitCallback, calcelCallback) {
	var modeless = new $.flavr({
		title : myFlavr.getTitle(),
		content : myFlavr.getContent(this),
		buttons : {
			primary : {
				style : 'primary',
				text : '确定',
				action : submitCallback
			},
			lesser : {
				style : 'default',
				text : '取消',
				action : calcelCallback
			}
		},
		onBuild : function() {//弹出框加载之后执行
			$('.flavr-title-close').click(function() {
				modeless.close();
			});
		}
	});
};
String.prototype.prompt = function(option) {
	var modeless = new $.flavr({
		title : myFlavr.getTitle(option.title),
		content : '<br/>',
		dialog : 'prompt',
		prompt : {
			placeholder : this
		},
		onConfirm : function($container, $prompt) {
			option.onSubmit($container, $prompt);
		},
		onCancel : function() {
			option.onCancel();
		},
		onBuild : function() {
			$(".flavr-title-close").click(function() {
				modeless.close();
			});
			option.onBuild();
		}
	});
}
/**
 * 提供jquery对象的初始化窗口方式 onCancel:function(){}, //取消时调用 onSubmit:function(){},
 * //确定时调用 myBuild: function(){}, //窗口初始化之后调用 onShow : function(){} //窗口显示后调用
 */
$.fn.initFlavr = function(option) {
	var title = this.find(".flavr-title-content")[0]
			|| myFlavr.getTitle(option.title);
	var modeless = void 0;
	this.option = {
		title : title,
		content : this.find(".flavr-message-content")[0],
		buttons : {
			primary : {
				style : 'primary',
				text : '确定',
				action : option.onSubmit
			},
			lesser : {
				style : 'default',
				text : '取消',
				action : option.onCancel
			}
		},
		onBuild : function() {
			$(".flavr-title-close").click(function() {
				modeless.close();
			});
			option.myBuild();
		}
	};
	delete option.onCancel;
	delete option.onSubmit;
	$.extend(true, this.option, option);
	modeless = new $.flavr(this.option);
	return modeless;
}



/**
 * 将textarea里的\n替换为<br>,空白字符替换为$nbsp
 */
String.prototype.textareaReplaceSpaceAndWrap = function() {
	var str=this,newStr="";
	if(str){
		$.each(str.split("\n"), function(i, n){
			newStr = newStr + n + "<br>";
		});
		newStr = newStr.replace(/\s/g, '&nbsp;');//\s   匹配任何空白字符，包括空格、制表符、换页符等等。等价于 [ \f\n\r\t\v]。	\g   全文匹配
	}
	return newStr;	
}




//////////////////
// WEBPACK FOOTER
// ./static/flavr/js/flavr.override.js
// module id = vD0m
// module chunks = 1